"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCouponEvents = exports.COUPON_SERVICE = exports.COUPON_EVENTS = void 0;
// `service` values sent with every coupon event — same as the app.
const COUPON_SERVICE = exports.COUPON_SERVICE = {
  LABS: 'labs',
  PHARMACY: 'pharmacy',
  OFFLINE_APPOINTMENT: 'offline appointment'
};
const COUPON_EVENTS = exports.COUPON_EVENTS = {
  COUPON_APPLIED_MODAL_VIEWED: 'Coupon Applied Modal Viewed',
  COUPON_APPLY_CLICKED: 'Coupon Apply Clicked',
  COUPON_REMOVE_CLICKED: 'Coupon Remove Clicked',
  COUPON_VIEW_ALL_CLICKED: 'Coupon View All Clicked',
  MANUAL_COUPON_CODE_APPLY_CLICKED: 'Manual Coupon Code Apply Clicked',
  COUPON_LIST_APPLY_CLICKED: 'Coupon List Apply Clicked',
  COUPON_LIST_REMOVE_CLICKED: 'Coupon List Remove Clicked'
};

/**
 * Amplitude events for the coupon flow on checkout screens built from the
 * coupon components here (offers card, Apply Coupon page, applied popup).
 * Create one per screen with that screen's context. `logEvent` is the client's
 * own logger — each client build wires analytics differently.
 */
const getCouponEvents = _ref => {
  let {
    logEvent,
    service,
    cartId,
    doctorId
  } = _ref;
  const log = (event, couponCode) => logEvent(event, {
    service: service || null,
    cartId: cartId ?? null,
    doctorId: doctorId ?? null,
    couponCode: couponCode || null
  });
  return {
    modalViewed: couponCode => logEvent(COUPON_EVENTS.COUPON_APPLIED_MODAL_VIEWED, {
      cartId: cartId ?? null,
      couponCode: couponCode || null,
      service: service || null
    }),
    // Apply/Remove on the offers card of the review screen itself.
    applyClicked: couponCode => log(COUPON_EVENTS.COUPON_APPLY_CLICKED, couponCode),
    removeClicked: couponCode => log(COUPON_EVENTS.COUPON_REMOVE_CLICKED, couponCode),
    // `couponCode` is the currently applied coupon, if any.
    viewAllClicked: couponCode => log(COUPON_EVENTS.COUPON_VIEW_ALL_CLICKED, couponCode),
    // Apply/Remove on the Apply Coupon page; `manual` means the code was typed
    // into the input rather than picked from the list.
    listApplyClicked: function (couponCode) {
      let {
        manual
      } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return log(manual ? COUPON_EVENTS.MANUAL_COUPON_CODE_APPLY_CLICKED : COUPON_EVENTS.COUPON_LIST_APPLY_CLICKED, couponCode);
    },
    listRemoveClicked: couponCode => log(COUPON_EVENTS.COUPON_LIST_REMOVE_CLICKED, couponCode)
  };
};
exports.getCouponEvents = getCouponEvents;